  function waitUntil(predicate, success, error) {
      var int = setInterval(() => {
                            if (predicate()) {
        clearInterval(int);
        int = null;
        success();
      }
    }, 33);
    setTimeout(() => {
               if (int !== null) {
      clearInterval(int);
      if (typeof (error) === 'function') {
        error();
      }
    }
    }, 20000);
    }

    function defineOptiReady() {
      const listeners = [];
      const doc = window.document;
      const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
      let observer;

      function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
          selector,
          fn
        });
        if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
            childList: true,
            subtree: true
          });
        }
        // Check if the element is currently in the DOM
        check();
      }

      function check() {
        // Check the DOM for elements matching a stored selector
        for (let i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (let j = 0, jLen = elements.length, element; j < jLen; j++) {
            element = elements[j];
            // Make sure the callback isn't invoked with the
            // same element more than once
            if (!element.ready) {
              element.ready = true;
              // Invoke the callback with the element
              listener.fn.call(element, element);
            }
          }
        }
      }

      // Expose 'ready'
      window.optiReady = ready;
    }


    defineOptiReady();

    waitUntil(() => typeof $ === 'function' && $('.cart-drawer__free-shipping').length > 0, () => {
      function chngesS(){
        $('.cart-drawer__free-shipping').insertAfter('.cart-drawer__header');

        if($('.textQuali').length==0){
          $('<span class="frSta">$0.00</span><span class="lasEnd">$95</span>').appendTo('.cart-drawer__free-shipping');
          $('.cart-drawer__free-shipping-progress').append('<img src="//cdn.shopify.com/s/files/1/0418/0662/6967/files/shipping-icon.png">');
          $("<span class='textQuali'>Congrats! You're qualified for Free Shipping</span>").insertAfter('.cart-drawer__free-shipping');
        }

        if(parseFloat($('.cart-drawer__total>span').eq(1).text().split('$')[1]) >= 65 && parseFloat($('.cart-drawer__total>span').eq(1).text().split('$')[1]) < 95){
          $('.cart-drawer__free-shipping').show();
        }else{
          $('.cart-drawer__free-shipping').hide();
        }

        if(parseFloat($('.cart-drawer__total>span').eq(1).text().split('$')[1]) > 95){
          $('.textQuali').show();
        }else{
          $('.textQuali').hide();	
        }
      }
      chngesS();

      optiReady('.cart-drawer__total',chngesS);

    });

